import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { setActiveStepById } from 'services/stepper/actions'
import { clearSelectedProduct } from 'services/products/actions'
import { sendGAEvent } from 'services/analytics/actions'
import { GA_EVENT_NAMES, STEPS } from 'utils/constants'

import Typography from 'ui/components/typography'
import { Box, Button, DialogContent, Grid } from '@material-ui/core'
import useStyles from './styles'
import { showModal } from 'services/modal/actions'
import { MODAL_TYPES } from 'services/modal/constants'

const NoService = ({ handleClose, data }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleSelectRateClick = () => {
    dispatch(sendGAEvent(GA_EVENT_NAMES.chooseAnotherRate, 'tarifa no disponible'))
    dispatch(clearSelectedProduct())
    dispatch(setActiveStepById(STEPS.rate))
    handleClose()
  }

  const handleCallMeButton = () => {
    dispatch(sendGAEvent(GA_EVENT_NAMES.callMeBackButton, 'tarifa no disponible'))
    dispatch(clearSelectedProduct())
    dispatch(setActiveStepById(STEPS.rate))
    dispatch(showModal({ modalType: MODAL_TYPES.callMeBack }))
  }

  return (
    <>
      <DialogContent className={classes.dialogContent}>
        <Box mb={3}>
          <Typography variant="h3" color="primary">
            {t('rateNotAvailable', { rate: data.productName })}
          </Typography>
        </Box>
        <Grid container>
          <Grid item xs={12} sm={8}>
            <Box mb={2}>
              <Button color="secondary" variant="contained" onClick={handleSelectRateClick}>
                {t('chooseAnotherRate')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="basic" color="textPrimary">
              <strong>{t('supply.address')}</strong>
            </Typography>
            <Typography variant="basic" color="textPrimary">
              {data.addressLines.map((addressLine, index) => (
                <span key={index}>
                  {addressLine}
                  <br />
                </span>
              ))}
            </Typography>
          </Grid>
        </Grid>
        <Box mt={3} mb={1}>
          <Typography variant="basic">
            <strong>{t('ifYouPrefer')}</strong>
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2} bgcolor="primary.light3">
          <Typography variant="basic" color="textPrimary">
            <strong>{t('common.contactUs')} </strong>
            {t('common.weHelpYou')}
          </Typography>
          <Button color="secondary" variant="outlined" onClick={handleCallMeButton}>
            {t('common.callMe')}
          </Button>
        </Box>
      </DialogContent>
    </>
  )
}

export default NoService
